<form action="auth-dialog_submit" method="get" accept-charset="utf-8">
  <h1>{{ 'Share Annotation to Collection' | translate }}</h1>

  <p>
    {{
      'To transfer this annotation to a collection, enter the identifier of the target collection.'
        | translate
    }}
  </p>

  <k-input
    [label]="'Collection identifier' | translate"
    type="text"
    (valueChanged)="targetCollectionId = $event.value"
  />

  <k-button-row align="end">
    <k-button (click)="share()">{{ 'Share' | translate }}</k-button>
    <k-button (click)="cancel()">{{ 'Cancel' | translate }}</k-button>
  </k-button-row>

  @if (checkPwdMode) {
  <p>{{ 'The target collection is protected by a password.' | translate }}</p>
  <p>{{ 'Enter the password to continue.' | translate }}</p>
  }

  <k-input
    [label]="'Password' | translate"
    type="password"
    (valueChanged)="passwordCollection = $event.value"
  />

  <k-button-row align="end">
    <k-button (click)="cancel()">{{ 'Cancel' | translate }}</k-button>
    <k-button (click)="checkPwd()">{{ 'Check' | translate }}</k-button>
  </k-button-row>
</form>
